import { useCallback, useContext } from 'react';

import { ModalsWrapperContext } from '@kanda-libs/ks-design-library';

import { useJobContext } from 'pages/Job/context';

import { REQUEST_CHANGES_MODAL_ID } from './constants';

export interface RequestChangesHook {
  isLoading: boolean;
  onClick: () => void;
}

export default function useRequestChanges(): RequestChangesHook {
  const { isLoading } = useJobContext();
  const { showModal } = useContext(ModalsWrapperContext);

  const onClick = useCallback(
    () => showModal(REQUEST_CHANGES_MODAL_ID),
    [showModal],
  );

  return { isLoading, onClick };
}
